/**
 * @file integrationConstants.js
 * @description Constants for the Integration module.
 *              Includes UI label strings, table configurations, messages, and error constants.
 *
 * @module integrationConstants
 *
 * @exports INTEGRATION_STRINGS   - UI label strings for the integration panel.
 * @exports INTEGRATION_KEYS      - Key mappings for integration data.
 * @exports INTEGRATION_TABLE_COLUMNS - Column definitions for the integration table.
 * @exports INTEGRATION_TABLE_COLUMN_KEYS - Column key mappings for the integration table.
 * @exports INTEGRATION_MESSAGES  - Message strings for integration operations.
 * @exports INTEGRATION_ERRORS    - Error message strings for integration data fetching.
 */
export const INTEGRATION_STRINGS = {
    INTEGRATIONS: "Permissions",
    SEARCH_PAGE: "Search Page",
    SEARCH_INTEGRATIONS: "Search Logs",
    SAVE_INTEGRATIONS: "Save Permissions",
    MODULE: "Module",
    PAGE: "Page"
};

export const INTEGRATION_KEYS = {
    INTEGRATION_NAME: "softwarename"
}

export const INTEGRATION_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "Id", isSortable: false, label: "ID" },
    { id: "softwaretype", isSortable: true, label: "Type" },
    { id: "softwarename", isSortable: true, label: "Application" },
    { id: "isSelected", isSortable: true, label: "Enabled" },
    { id: "createdAt", isSortable: true, label: "Date" },
    { id: "integrationsoftid", isSortable: true, label: "integrationsoftid" },
    { id: "integrationtype", isSortable: true, label: "Feature" },
    { id: "enRead", isSortable: true, label: "Read" },
    { id: "dpRead", isSortable: true, label: "dpRead" },
    { id: "enCreate", isSortable: true, label: "Create" },
    { id: "dpCreate", isSortable: true, label: "dpCreate" },
    { id: "enEdit", isSortable: true, label: "Edit" },
    { id: "enDelete", isSortable: true, label: "Delete" },
    { id: "dpDelete", isSortable: true, label: "dpDelete" }
];

export const INTEGRATION_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    INTEGRATION_ID: "softwarename"
};


export const INTEGRATION_MESSAGES = {
    NO_INTEGRATIONS: "No integrations to display",
    NO_PAGES: "No pages found for this integration."
};

export const INTEGRATION_ERRORS = {
    FETCH_INTEGRATIONS_ERROR: "Error fetching integrations."
};
